import QTable from 'quasar/src/components/table/QTable.js';

export const adminInvoiceItemTableColumns = (): QTable['columns'] => [
  {
    name: 'title',
    field: 'title',
    label: 'عنوان',
    align: 'center',
    style: 'max-width: 500px;width:300px'
  },
  {
    name: 'price',
    field: 'price',
    label: 'قیمت واحد',
    align: 'center'
  },
  {
    name: 'quantity',
    field: 'quantity',
    label: 'تعداد',
    align: 'center'
  },
  {
    name: 'discount',
    field: 'discount',
    label: 'تخفیف',
    align: 'center'
  },
  {
    name: 'payable',
    field: 'payable',
    label: 'قابل پرداخت',
    align: 'center'
  }
]
